import Vue from 'vue'
import Vuex from 'vuex'
import mutations from '@/product/store/mutations'
import actions from '@/product/store/actions'
import getters from '@/product/store/getters'

import {
  ProductState,
  ProductDetailModel,
  ProductEstimate,
  PRODUCT_SELECTION_ERROR_TYPES
} from '@/product/types'
import { PRODUCT_INVALID_SELECTIONS } from '@/product/const'

Vue.use(Vuex)

export default new Vuex.Store<ProductState>({
  state: {
    productDetail: {
      product: {},
      sku: {}
    } as ProductDetailModel,
    estimate: {} as ProductEstimate,
    imageLoading: false,
    validQuantity: true,
    serverError: false,
    productLoading: false,
    sizeInput: [],
    addonProducts: [],
    addonProduct: {
      selectedAddonProductId: undefined,
      selectedAddonFirstOptionId: undefined
    },
    additionalOptions: [],
    selectedAdditionalOptionIds: [],
    isPrintingSelected: false,
    stockLibraryDesign: {
      uuid: undefined,
      imageUrl: undefined,
      userDesignVersionUuid: ''
    },
    selectionErrors: {
      [PRODUCT_SELECTION_ERROR_TYPES.PRODUCT_SIZE]: {
        errorMessage: 'サイズ・数量を入力してください',
        highlightInvalidElement: false
      },
      [PRODUCT_SELECTION_ERROR_TYPES.PRODUCT_SET]: {
        errorMessage: '付属品の種類を選択してください',
        highlightInvalidElement: false
      },
      [PRODUCT_SELECTION_ERROR_TYPES.PRINTING_OPTION]: {
        errorMessage: '印刷方法が未選択です',
        highlightInvalidElement: false
      }
    },
    isMobileView: false,
    snackbarMessage: PRODUCT_INVALID_SELECTIONS,
    maxQuantity: -1
  } as ProductState,
  mutations,
  actions,
  getters
})
